import { IBreadcrumb, IMenuItem, INavMenu } from '@/types';

export const useMenuStore = defineStore('menu', () => {
    const navMenuMarketsTB = ref<INavMenu>({
        title: 'markets',
        icon: mdiSoccer,
        subItems: [
            { title: 'favourite', breadcrumb: 'breadcrumb_favourite', icon: mdiStar, iconColor: 'favStarOn', link: 'favourite' },
            { title: 'orders' },
            { title: 'live', breadcrumb: 'breadcrumb_live', link: 'feedLive' },
            { title: 'pregame', breadcrumb: 'breadcrumb_pregame', link: 'feedDball', divider: true },
            { title: 'bots' },
            { title: 'botLiveFeed', breadcrumb: 'breadcrumb_botLiveFeed', link: 'feedLiveBot' },
            { title: 'botPregame', breadcrumb: 'breadcrumb_botPregame', link: 'feedDballBot' },
        ],
    });
    const navMenuTrading = ref<INavMenu>({
        title: 'trading',
        icon: mdiListBoxOutline,
        subItems: [
            { title: 'bets', link: 'bet' },
            { title: 'orders', link: 'order' },
            { title: 'errorLog', link: 'betFail' },
        ],
    });
    const navMenuTradingWL = ref<INavMenu>({
        title: 'trading',
        icon: mdiListBoxOutline,
        subItems: [
            { title: 'bets', link: 'bet' },
            { title: 'orders', link: 'order' },
        ],
    });
    const navMenuMarketsWL = ref<INavMenu>({
        title: 'markets',
        icon: mdiSoccer,
        subItems: [
            { title: 'orders' },
            { title: 'live', breadcrumb: 'breadcrumb_live', link: 'feedLive' },
            { title: 'pregame', breadcrumb: 'breadcrumb_pregame', link: 'feedDball', divider: true },
            { title: 'bots' },
            { title: 'botLiveFeed', breadcrumb: 'breadcrumb_botLiveFeed', link: 'feedLiveBot' },
            { title: 'botPregame', breadcrumb: 'breadcrumb_botPregame', link: 'feedDballBot' },
        ],
    });
    const navMenuTools = ref<INavMenu>({
        title: 'tools',
        icon: mdiTools,
        subItems: [
            { title: 'leagueGroups', link: 'leagueGroup' },
            { title: 'leagues', link: 'league' },
            { title: 'teams', link: 'team' },
        ],
    });
    const navMenuSupportItems = ref<IMenuItem[]>([
        { title: 'terms', link: 'terms-conditions' },
        { title: 'guide', link: 'guide' },
    ]);
    const navMenuWLSupportItems = ref<IMenuItem[]>([
        {
            title: 'terms',
            link: 'terms-conditions',
        },
        {
            title: 'rules',
            link: 'rules',
        },
        {
            title: 'how-to-place-bet',
            link: 'how-to-place-bet',
        },
        {
            title: 'guide',
            link: 'guide',
        },
        {
            title: 'responsible-gambling',
            link: 'responsible-gambling',
        },
        {
            title: 'cookies',
            link: 'cookies-policy',
        },
    ]);
    const breadcrumbs = ref<IBreadcrumb[]>([]);
    const withMenu = ref<boolean>(false);
    const userMenu = ref<boolean>(false);
    const notificationMenu = ref<boolean>(false);
    const notificationBadge = ref<boolean>(false);
    const mobileMenuDrawer = ref<boolean>(false);

    const getNavMenuItemsGuest = computed((): IMenuItem[] => [
        {
            title: 'markets',
            icon: mdiSoccer,
            subItems: [
                { title: 'orders' },
                {
                    title: 'live',
                    breadcrumb: 'breadcrumb_live',
                    link: 'feedLive',
                },
                {
                    title: 'pregame',
                    breadcrumb: 'breadcrumb_pregame',
                    link: 'feedDball',
                },
            ],
        },
    ]);
    const getNavMenuItems = computed((): IMenuItem[] => [navMenuMarketsTB.value, { title: 'bots', link: 'bot' }, navMenuTrading.value, navMenuTools.value]);
    const getNavMenuItemsWL = computed((): IMenuItem[] => [
        {
            title: 'favourite',
            link: 'favourite',
            icon: mdiStar,
            iconColor: 'favStarOn',
        },
        navMenuMarketsWL.value,
        { title: 'bots', link: 'bot' },
        navMenuTradingWL.value,
        navMenuTools.value,
    ]);

    function setBreadcrumbs(value: IBreadcrumb[]) {
        // Replace with actual translation in component
        breadcrumbs.value = value.map((item) => ({
            ...item,
            text: `menu.${item.text}`,
        }));
    }

    function setNotificationBadge(notification: any[]) {
        notificationBadge.value = notification?.length > 0;
    }

    return {
        getNavMenuItems,
        getNavMenuItemsWL,
        getNavMenuItemsGuest,
        setBreadcrumbs,
        setNotificationBadge,
        withMenu,
        userMenu,
        notificationMenu,
        notificationBadge,
        mobileMenuDrawer,
        navMenuSupportItems,
        navMenuWLSupportItems,
    };
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useMenuStore, import.meta.hot));
}
